import resource from "../../model/resource.js";
import http from '@/common/http.js';
import omggif from 'omggif';

var uploadData = {};
//检查文件是否合法
function checkFiles(params, success){
	let files = params.files.tempFiles;
	let idx = 0;
	let errFiles = [];
	
	for(let i in files)
	{
		let file = files[i];
		
		if(params.type == 'hotspotImage') {
			dyEditor.util.imageScale({
				file 	: file,
				width	: 2000,
				success	: img=>{
					files[i] = img;
					
					//检查完成
					if(idx++ >= files.length -1) {
						files = files.filter(item => {
							return !item.err;
						});
						
						if(errFiles.length>0){
							dyEditor.dialog.files({
								title:'系统提示',
								height:'550px',
								files:errFiles
							});
						}
						
						success && success(files);
					}
				}
			});
		} else {
			if(params.maxSize && file.size > params.maxSize){
				file.err = true;
				errFiles.push({
					name: file.name,
					text: '文件超出' + parseInt(params.maxSize / 1024 / 1024) + 'MB的最大限制，无法上传',
				});
			}
			
			if(params.max && i>=params.max){
				file.err = true;
				errFiles.push({
					name: file.name,
					text: '超出最大数量上限，无法上传',
				});
			}
			
			//检查完成
			if(idx++ >= files.length -1) {
				files = files.filter(item => {
				    return !item.err;
				});
						
				if(errFiles.length>0){
					dyEditor.dialog.files({
						title:'系统提示',
						height:'550px',
						files:errFiles
					});
				}
				
				success && success(files);
			}
		}
	}
}

//上传图册图片
function uploadImage(params){
	checkFiles(params, files=>{
		params.checkd && params.checkd(files);
		
		resource.uploadFiles(dy3d.config.id, files, {
			type : params.type,
			ready : res=>{
				let item = {id:res.id, name:res.name, size:res.size, file:res.file, text:''};
				params.hotspot.target.images.push(item);
				return params.hotspot.target.images[params.hotspot.target.images.length-1];
			},
			success	: res=>{
				res.item.progress	= 0;
				res.item.url = dy3d.manager.getPath(res.item.file);
				params.success && params.success(files);
			},
			progress : res=>{
				res.item.progress = res.num;
				params.progress && params.progress(res.num);
			},
			error : res=>{
				params.error && params.error(res);
				dyEditor.toast.error('图片上传失败!');
			}
		});
	});
}

//上传视频
function uploadVideo(params){
	checkFiles(params, files=>{
		resource.uploadFiles(dy3d.config.id, files, {
			type : params.type,
			ready : res=>{
				let item = {id:res.id, name:res.name, size:res.size, file:res.file};
				params.hotspot.target.videos.push(item);
				return params.hotspot.target.videos[params.hotspot.target.videos.length-1];
			},
			success	: res=>{
				res.item.progress	= 0;
				res.item.url		= dy3d.manager.getPath(res.item.file);
				res.item.preview	= res.item.url.replace('.mp4', '.jpg');
				
				params.success && params.success(files);
			},
			progress : res=>{
				res.item.progress = res.num;
				params.progress && params.progress(res.num);
			},
			error : res=>{
				params.error && params.error(res);
				dyEditor.toast.error('视频上传失败!');
			}
		});
	});
}

//上传PDF
function uploadPDF(params){
	checkFiles(params, files=>{
		resource.uploadFiles(dy3d.config.id, files, {
			type : params.type,
			ready : res=>{
				let item = {id:res.id, name:res.name, size:res.size, file:res.file};
				params.hotspot.target.pdfs.push(item);
				return params.hotspot.target.pdfs[params.hotspot.target.pdfs.length-1];
			},
			success	: res=>{
				res.item.progress	= 0;
				res.item.url		= dy3d.manager.getPath(res.item.file);
				params.success && params.success(files);
			},
			progress : res=>{
				res.item.progress = res.num;
				params.progress && params.progress(res.num);
			},
			error : res=>{
				params.error && params.error(res);
				dyEditor.toast.error('PDF上传失败!');
			}
		});
	});
}

//上传音乐
function uploadMusic(params){
	checkFiles(params, files=>{
		resource.uploadFiles(dy3d.config.id, files, {
			type : params.type,
			ready : res=>{
				let item = {id:res.id, name:res.name, size:res.size, file:res.file};
				params.hotspot.target.musics.push(item);
				return params.hotspot.target.musics[params.hotspot.target.musics.length-1];
			},
			success	: res=>{
				res.item.progress	= 0;
				res.item.url		= dy3d.manager.getPath(res.item.file);
				params.success && params.success(files);
			},
			progress : res=>{
				res.item.progress = res.num;
				params.progress && params.progress(res.num);
			},
			error : res=>{
				params.error && params.error(res);
				dyEditor.toast.error('音乐上传失败!');
			}
		});
	});
}

//上传图片图标
function uploadIconImage(params){
	let url = params.file.tempFiles[0];
	
	function onUpload(img){
		resource.upload({
			file	: img,
			form	: {
				"id": dy3d.config.id,
				'type':'hotspotIconImage'
			},
			success:(r)=>{
				let w,h;
		
				new Promise((resolve, reject)=>{
					if(r.file.substr(-3).toLowerCase() == 'gif'){
						const fr = new FileReader();
						fr.addEventListener("loadend", (e) => {
							const data 	= new Uint8Array(e.target.result);
							const gr	= new omggif.GifReader(data);
							w = gr.width / 800;
							h = gr.height / 800;
							resolve();
						});
						fr.readAsArrayBuffer(img);
					} else {
						w = img.width / 800;
						h = img.height / 800;
						resolve();
					}
				}).then(()=>{
					if(w>h && w>1){
						h = h / w;
						w = 1;
					}
					
					if(h>w && h>1){
						w = w / h;
						h = 1;
					}
					
					params.hotspot.icon		= dy3d.manager.getPath(r.file);
					params.hotspot.width	= w;
					params.hotspot.height	= h;
					params.hotspot.size		= img.size;
					params.hotspot.status	= 1;
					
					params.success && params.success(params.hotspot);
				})
			},
			progress:(res)=>{
				params.progress && params.progress(res);
			},
			error:(res)=>{
				params.error && params.error(res);
				dyEditor.toast.error('热点自定义图标上传失败!');
			}
		});
	}
	
	if(url.name.slice(-4) == '.gif'){
		onUpload(params.file.tempFiles[0]);
	} else {
		dyEditor.util.imageScale({
			file 	: url,
			width	: 2000,
			success	: img=>onUpload(img)
		});
	}
}

//上传视频图标
function uploadIconVideo(params){
	if(params.file.size > 200 * 1024 * 1024){
		dyEditor.toast.error('上传的视频不能超出200MB');
		return;
	}
	
	// 限制宽高,目前版本放开
	// if(res.width >640 || res.height >480)
	// {
	// dyEditor.toast.error('图标视频宽高不能超过640/480px！');
	// 	return;
	// }
	
	resource.upload({
		file	: params.file.tempFile,
		form	: {
			"id": dy3d.config.id,
			'type':'hotspotIconVideo'
		},
		success:(res)=>{
			if(!params.file.width) params.file.width = 800;
			if(!params.file.height) params.file.height = 800;
			params.hotspot.icon		= dy3d.manager.getPath(res.file);
			params.hotspot.preview	= params.hotspot.icon.replace('.mp4', '.jpg');
			params.hotspot.width	= params.file.width / 800;
			params.hotspot.height	= params.file.height / 800;
			params.hotspot.size		= params.file.size;
			params.hotspot.status	= 1;
			params.success && params.success(res);
		},
		progress:(res)=>{
			params.progress && params.progress(res);
		},
		error:(res)=>{
			params.error && params.error(res);
			dyEditor.toast.error('热点自定义图标上传失败!');
		}
	});
}

//上传模型图标
function uploadIconModel(params){
	
	resource.upload({
		file	: params.file,
		form	: {
			"id": dy3d.config.id,
			'type':'uploadIconModel'
		},
		
		success:(r)=>{
			uploadData.resourceId = r.resourceId;
			uploadData.id 		  = params.hotspot.id;
			//params.hotspot.icon 	= dy3d.manager.getPath(r.file);
			params.hotspot.size		= params.file.size;
			params.hotspot.status	= 1;
			params.success && params.success(r);
		},
		progress:(res)=>{
			params.progress && params.progress(res);
		},
		error:(res)=>{
			params.error && params.error(res);
			dyEditor.toast.error('热点自定义模型上传失败!');
		}
	});
}

//上传联系人头像
function uploadFace(params){
	dyEditor.util.imageScale({
		file 	: params.files.tempFiles[0],
		width	: 100,
		success	: img=>{
			resource.upload({
				file	: img,
				form	: {
					"id"	: dy3d.config.id,
					'type'	: params.type,
				},
				success:(r)=>{
					params.data.url		= dy3d.manager.getPath(r.file);
					params.data.size	= img.size;
				},
				progress:(res)=>{
					// console.log(res);
					params.data.progress = res;
					params.progress && params.progress(res);
				},
				error:(res)=>{
					params.error && params.error(res);
					dyEditor.toast.error('头像上传失败!');
				}
			});
		}
	});
}

//上传文章封面
function uploadCover(params){
	dyEditor.util.imageScale({
		file 	: params.file.tempFiles[0],
		width	: 512,
		success	: img=>{
			resource.upload({
				file	: img,
				form	: {
					"id"	: dy3d.config.id,
					'type'	: params.type,
				},
				success:(r)=>{
					params.data.cover	= dy3d.manager.getPath(r.file);
					params.data.size	= img.size;
					params.success && params.success(params);
				},
				progress:(res)=>{
					// params.data.progress = res;
					params.progress && params.progress(res);
				},
				error:(res)=>{
					params.error && params.error(res);
					dyEditor.toast.error('封面上传失败!');
				}
			});
		}
	});
}

//上传序列帧图标
function uploadGIFIconImage(params){
	let url = params.file.tempFiles[0];

	function onUpload(img){
		resource.upload({
			file	: img,
			form	: {
				"id": dy3d.config.id,
				'type':'hotspotIconImage'
			},
			success:(r)=>{
				let w = img.width / 800;
				let h = img.height / 800;
		
				if(w>h && w>1){
					h = h / w;
					w = 1;
				}
				
				if(h>w && h>1){
					w = w / h;
					h = 1;
				}
				
				let m = w>h ? h : w;
				params.hotspot.icon		= dy3d.manager.getPath(r.file);
				params.hotspot.width	= w;
				params.hotspot.height	= h;
				params.hotspot.size		= img.size;
				params.hotspot.status	= 1;
				if(params.hotspot.iconType == 5){
					let iw = img.originWidth;
					let ih = img.originHeight;
					
					let frame	= iw>ih ? iw/ih : ih/iw;
					if(frame != parseInt(frame)){
						let ii = Math.max(iw,ih);
						if(ii/10 == parseInt(ii/10)) frame = 10;
						else if(ii/20 == parseInt(ii/20)) frame = 20;
						else if(ii/30 == parseInt(ii/30)) frame = 30;
						else if(ii/40 == parseInt(ii/40)) frame = 40;
						else if(ii/24 == parseInt(ii/24)) frame = 24;
						else if(ii/15 == parseInt(ii/15)) frame = 15;
						else if(ii/16 == parseInt(ii/16)) frame = 16;
						else if(ii/8  == parseInt(ii/8))  frame = 8;
						else {
							for(let n=40; n>5; n--){
								if(ii/n == parseInt(ii/n)) frame = n;
							}
						}
					}
					
					params.hotspot.frame = frame;
					iw>ih ? params.hotspot.width /= frame : params.hotspot.height /= frame
				}
				
				params.success && params.success(params.hotspot);
			},
			progress:(res)=>{
				params.progress && params.progress(res);
			},
			error:(res)=>{
				params.error && params.error(res);
				dyEditor.toast.error('热点自定义图标上传失败!');
			}
		});
	}
	
	if(url.name.slice(-4) == '.gif'){
		onUpload(params.file.tempFiles[0]);
	} else {
		dyEditor.util.imageScale({
			file 	: url,
			width	: 300,
			height	: 4096,
			type	: 'image/png',
			success	: img=>onUpload(img)
		});
	}
}

let ckUploadCount = 0;

function getUploadCount(){
	return ckUploadCount;
}

//上传文章内容图片
function uploadDocImage(params){
	let url = params.file;
	function onUpload(img){
		ckUploadCount++;
		resource.upload({
			file	: img,
			form	: {
				"id": dy3d.config.id,
				'type':'hotspotIconImage'
			},
			success:(r)=>{
				ckUploadCount--;
				params.success && params.success(r);
			},
			progress:(res)=>{
				params.progress && params.progress(res);
			},
			error:(res)=>{
				ckUploadCount--;
				params.error && params.error(res);
				dyEditor.toast.error('文章内容图片上传失败!');
			}
		});
	}
	
	dyEditor.util.imageScale({
		file 	: url,
		width	: 2000,
		success	: img=>onUpload(img)
	});
}


//上传文章内容视频
function uploadDocVideo(params){
	let url = params.file;

	ckUploadCount++;
	resource.upload({
		file	: url,
		form	: {
			"id": dy3d.config.id,
			'type':'hotspotIconVideo'
		},
		success:(r)=>{
			ckUploadCount--;
			params.success && params.success(r);
		},
		progress:(res)=>{
			params.progress && params.progress(res);
		},
		error:(res)=>{
			ckUploadCount--;
			params.error && params.error(res);
			dyEditor.toast.error('文章内容视频上传失败!');
		}
	});
}

//获取3D模型列表
function getModels(params,success){
	if(!params) params = {};
	let url = '/threedmodel/list';
	if(params.albumId != undefined && params.albumId!='') url += (url.indexOf('?')>-1?'&':'?')+'albumid=' + params.albumId;
	if(params.content != undefined && params.content!='') url += (url.indexOf('?')>-1?'&':'?')+'content=' + params.content;
	if(params.page != undefined && params.page!='') url += (url.indexOf('?')>-1?'&':'?')+'page=' + params.page;
	http.request({
		url 	: url,
		success	: res=>{
			success && success(res);
		}
	})
}

//上传载入图标
function uploadLoadingImg(params,success){			
	dyEditor.util.imageScale({
		file 	: params.file.tempFiles[0],
		width	: 200,
		success	: img=>{		
			resource.upload({
				file	: img,
				form	: {
					"id": dy3d.config.id,
					'type':'hotspotIconImage'
				},
				success:(r)=>{
					console.log('upload',params);
					params.params.url	= dy3d.manager.getPath() + r.file;
					params.params.size	= img.size;
					success && success();
				},
				progress:(res)=>{
					params.progress && params.progress(res);
				},
				error:(res)=>{
					params.error && params.error(res);
					dyEditor.toast.error('载入图片上传失败!');
				}
			});
		}
	});
}

function getUploadData(){
	return uploadData;
}

export default {
	uploadImage,
	uploadVideo,
	uploadFace,
	uploadCover,
	uploadPDF,
	uploadMusic,
	uploadIconVideo,
	uploadIconImage,
	uploadGIFIconImage,
	uploadDocImage,
	uploadDocVideo,
	getModels,
	getUploadCount,
	uploadLoadingImg,
	uploadIconModel,
	getUploadData,
}